import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { IUserProfile } from '../../../user/interfaces/IUserProfile';
import { IMessageableEntity } from '../../interfaces/IMessageableEntity';

@Component({
  selector: 'ngx-list-members-channel-to-call',
  templateUrl: './list-members-channel-to-call.component.html',
  styleUrls: ['./list-members-channel-to-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListMembersChannelToCallModalComponent {
  pageMembers = 0;
  membersToCall: IMessageableEntity[] = [];
  user: IUserProfile;

  constructor(private dialogRef: MatDialogRef<ListMembersChannelToCallModalComponent>) {}

  close(): void {
    this.dialogRef.close(null);
  }

  callMembers() {
    this.dialogRef.close(this.membersToCall.map((member) => member.businessReference!.entityUID));
  }
}
